(() => {
  // recalled-shop-home v7 — Gewerbe only with customer type/tag
  const root = document.querySelector('[data-shop-home]');
  if (!root) return;

  const batchSize = Number(root.dataset.batchSize || 24);
  const moneyFormat = (cents) => {
    try {
      return new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR',
      }).format(cents / 100);
    } catch {
      return `${(cents / 100).toFixed(2)} €`;
    }
  };

  let mode = 'privat';
  let availability = 'available';
  const visibleCountByPanel = new Map();
  const selectedBulk = new Map(); // variantId -> { price, title, el }

  const privatView = root.querySelector('[data-shop-view="privat"]');
  const gewerbeView = root.querySelector('[data-shop-view="gewerbe"]');
  const modeBtns = [...root.querySelectorAll('[data-shop-mode]')];
  const orbs = [...root.querySelectorAll('[data-shop-orb]')];
  const privatPanels = [...root.querySelectorAll('[data-shop-view="privat"] [data-shop-panel]')];

  function shuffleInPlace(items) {
    for (let i = items.length - 1; i > 0; i -= 1) {
      const j = Math.floor(Math.random() * (i + 1));
      [items[i], items[j]] = [items[j], items[i]];
    }
    return items;
  }

  function shufflePanelCards(panel) {
    if (panel?.dataset.shufflePanel !== 'true') return;
    const grid = panel.querySelector('[data-shop-grid]');
    if (!grid) return;
    const cards = [...grid.querySelectorAll('.shop-home__card')];
    shuffleInPlace(cards);
    cards.forEach((card) => grid.appendChild(card));
  }

  function matchingCards(panel) {
    return [...panel.querySelectorAll('.shop-home__card')].filter((card) => {
      if (card.matches('[data-bulk-pick]')) return false;
      const soldOut = card.getAttribute('data-sold-out') === 'true';
      if (availability === 'available') return !soldOut;
      return true;
    });
  }

  function applyFilter(panel) {
    if (!panel) return;
    const cards = matchingCards(panel);
    const shown = visibleCountByPanel.get(panel) || batchSize;

    panel.querySelectorAll('.shop-home__card:not([data-bulk-pick])').forEach((card) => {
      const soldOut = card.getAttribute('data-sold-out') === 'true';
      const matches = availability === 'all' || !soldOut;
      if (!matches) {
        card.hidden = true;
        return;
      }
      const matchIndex = cards.indexOf(card);
      card.hidden = matchIndex < 0 || matchIndex >= shown;
    });

    panel.querySelectorAll('[data-availability]').forEach((btn) => {
      btn.classList.toggle('is-active', btn.dataset.availability === availability);
    });

    const wrap = panel.querySelector('[data-load-more-wrap]');
    if (wrap) wrap.hidden = shown >= cards.length;
  }

  function selectPrivatCategory(key) {
    orbs.forEach((orb) => {
      const selected = orb.dataset.category === key;
      orb.classList.toggle('is-selected', selected);
      orb.setAttribute('aria-selected', selected ? 'true' : 'false');
    });
    privatPanels.forEach((panel) => {
      const match = panel.dataset.shopPanel === key;
      panel.hidden = !match;
      if (match) {
        shufflePanelCards(panel);
        visibleCountByPanel.set(panel, batchSize);
        applyFilter(panel);
      }
    });
  }

  function setMode(next) {
    mode = next;
    modeBtns.forEach((btn) => {
      const on = btn.dataset.shopMode === next;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    if (privatView) privatView.hidden = next !== 'privat';
    if (gewerbeView) gewerbeView.hidden = next !== 'gewerbe';
    if (next === 'privat') {
      const active = orbs.find((o) => o.classList.contains('is-selected')) || orbs[0];
      if (active) selectPrivatCategory(active.dataset.category);
    } else {
      showGewerbeHub();
    }
  }

  function showGewerbeHub() {
    root.querySelectorAll('[data-gewerbe-panel]').forEach((p) => {
      p.hidden = true;
    });
    const hub = root.querySelector('[data-gewerbe-hub]');
    if (hub) hub.hidden = false;
  }

  function openGewerbePanel(name) {
    const hub = root.querySelector('[data-gewerbe-hub]');
    if (hub) hub.hidden = true;
    root.querySelectorAll('[data-gewerbe-panel]').forEach((p) => {
      const match = p.dataset.gewerbePanel === name;
      p.hidden = !match;
      if (match) {
        visibleCountByPanel.set(p, batchSize);
        applyFilter(p);
      }
    });
  }

  function updateBulkUi() {
    const count = selectedBulk.size;
    const countEl = root.querySelector('[data-bulk-count]');
    const bar = root.querySelector('[data-bulk-bar]');
    const totalEl = root.querySelector('[data-bulk-total]');
    const addBtn = root.querySelector('[data-bulk-add]');
    const hint = root.querySelector('[data-bulk-hint]');
    const ready = count >= 10;

    if (countEl) countEl.textContent = String(count);
    if (bar) bar.style.width = `${Math.min(100, (count / 10) * 100)}%`;
    if (bar) bar.parentElement?.classList.toggle('is-ready', ready);

    let full = 0;
    selectedBulk.forEach((item) => {
      full += Number(item.price) || 0;
    });
    const disc = Math.round(full * 0.7);

    if (totalEl) {
      if (count > 0) {
        totalEl.hidden = false;
        totalEl.innerHTML = ready
          ? `<s>${moneyFormat(full)}</s> ${moneyFormat(disc)} · 30% Bulk-Rabatt aktiv`
          : `${moneyFormat(full)} · noch ${10 - count}`;
      } else {
        totalEl.hidden = true;
      }
    }

    if (addBtn) addBtn.disabled = !ready;
    if (hint) {
      hint.textContent = ready
        ? '30% Rabatt wird an der Kasse über den Bulk-Hinweis vermerkt — bitte Rabattcode/Setup prüfen.'
        : 'Wähle mindestens 10 Pieces.';
    }
  }

  function toggleBulkPick(btn) {
    const id = btn.dataset.variantId;
    if (!id) return;
    if (selectedBulk.has(id)) {
      selectedBulk.delete(id);
      btn.classList.remove('is-picked');
    } else {
      selectedBulk.set(id, {
        price: Number(btn.dataset.price) || 0,
        title: btn.dataset.title || '',
        el: btn,
      });
      btn.classList.add('is-picked');
    }
    updateBulkUi();
  }

  async function addBulkToCart() {
    if (selectedBulk.size < 10) return;
    if (root.dataset.loggedIn !== 'true') {
      const loginUrl = root.dataset.loginUrl || '/account/login';
      window.location.href = loginUrl;
      return;
    }
    const addBtn = root.querySelector('[data-bulk-add]');
    if (addBtn) {
      addBtn.disabled = true;
      addBtn.textContent = 'Wird hinzugefügt…';
    }

    const items = [...selectedBulk.entries()].map(([id]) => ({
      id: Number(id),
      quantity: 1,
      properties: {
        _custom_bulk: 'true',
        Bulk: 'Eigener Bulk · 30% Rabatt',
      },
    }));

    try {
      // clear then add in chunks of 5 for reliability
      await fetch('/cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } });
      for (let i = 0; i < items.length; i += 5) {
        const chunk = items.slice(i, i + 5);
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: chunk }),
        });
        if (!res.ok) throw new Error('add failed');
      }
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: `Eigener Bulk · ${items.length} Artikel · 30% Rabatt` }),
      });
      window.location.href = '/cart';
    } catch {
      if (addBtn) {
        addBtn.disabled = false;
        addBtn.textContent = 'In Warenkorb hinzufügen';
      }
      const hint = root.querySelector('[data-bulk-hint]');
      if (hint) hint.textContent = 'Fehler beim Hinzufügen — bitte erneut versuchen.';
    }
  }

  function openAccountMenu() {
    const desktopTrigger = document.querySelector(
      '.account-popover [popovertarget="account-popover"], .account-popover button, #account-popover-button'
    );
    const mobileTrigger = document.querySelector(
      '.account-drawer [on\\:click="/showDialog"], .account-drawer button, .account-drawer summary'
    );
    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    const trigger = isMobile ? mobileTrigger || desktopTrigger : desktopTrigger || mobileTrigger;
    if (trigger) {
      trigger.click();
      return;
    }
    const panel = document.getElementById('account-popover');
    if (panel?.showPopover) panel.showPopover();
  }

  modeBtns.forEach((btn) => {
    btn.addEventListener('click', () => setMode(btn.dataset.shopMode));
  });

  root.querySelectorAll('[data-open-account]').forEach((btn) => {
    btn.addEventListener('click', () => openAccountMenu());
  });

  orbs.forEach((orb) => {
    orb.addEventListener('click', () => selectPrivatCategory(orb.dataset.category));
  });

  root.querySelectorAll('[data-availability]').forEach((btn) => {
    btn.addEventListener('click', () => {
      availability = btn.dataset.availability || 'all';
      const panel = [...privatPanels].find((p) => !p.hidden);
      if (panel) {
        visibleCountByPanel.set(panel, batchSize);
        applyFilter(panel);
      }
    });
  });

  root.querySelectorAll('[data-load-more]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const panel = btn.closest('[data-shop-panel], [data-gewerbe-panel]');
      if (!panel) return;
      const current = visibleCountByPanel.get(panel) || batchSize;
      visibleCountByPanel.set(panel, current + batchSize);
      applyFilter(panel);
    });
  });

  root.querySelectorAll('[data-gewerbe-open]').forEach((btn) => {
    btn.addEventListener('click', () => openGewerbePanel(btn.dataset.gewerbeOpen));
  });

  root.querySelectorAll('[data-gewerbe-back]').forEach((btn) => {
    btn.addEventListener('click', () => showGewerbeHub());
  });

  root.querySelectorAll('[data-bulk-source]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const source = btn.dataset.bulkSource;
      root.querySelectorAll('[data-bulk-source]').forEach((b) => {
        b.classList.toggle('is-active', b === btn);
      });
      root.querySelectorAll('[data-bulk-grid]').forEach((grid) => {
        grid.hidden = grid.dataset.bulkGrid !== source;
      });
    });
  });

  root.querySelectorAll('[data-bulk-pick]').forEach((btn) => {
    btn.addEventListener('click', () => toggleBulkPick(btn));
  });

  root.querySelector('[data-bulk-add]')?.addEventListener('click', () => {
    addBulkToCart();
  });

  setMode('privat');
})();
